/* Panel Nav: In Page Panel Navigation
=========================================== */
$.fn.panelNavigation = function(){
	/**
	*  affix the #panelNav below:
	*  global nav [.main-head]
	*  hero [.hero-panel]
	*/
	// Eject if there's an empty call
	if( !$(this).length ) { return false; };

	var offsetTop = $('.main-head').height()+$('.hero-panel__image').height(),
			navBarHeight = $(this).height(),
			mainHeadHeight = $('.main-head').height(),
			panelNavOffset = $('.panel-nav').offset();

			$(this).affix({
				offset: {
					// Set the nav element to fixed
					//top: (offsetTop) - navBarHeight - 150
					top: panelNavOffset.top - (mainHeadHeight * 2)
				}
			});

			/* highlight the top nav as scrolling occurs */
			$('body').scrollspy({ target: '#panelNav', offset: navBarHeight + mainHeadHeight });

			/* smooth scrolling for nav sections */
			$('#panelNav .navbar-nav li>a').click(function(e){
				e.preventDefault();

				var panelOffset = navBarHeight + mainHeadHeight,
						link = $(this).attr('href'),
						posi = $(link).offset().top - panelOffset + 5;

				$('html, body').animate({scrollTop:posi},700);
			})
	/* end: in page panel navigation ========== */

};
